import Plyr from "plyr-react";
import "./_plyr.css";

type VideoPlayerProps = {
  src: string;
};

const VideoPlayer = ({ src }: VideoPlayerProps) => (
  <Plyr
    source={{
      type: "video",
      sources: [
        {
          src,
        },
      ],
    }}
    options={{
      tooltips: { controls: true, seek: true },
      speed: {
        selected: 1,
        options: [1, 1.25, 1.5, 1.75, 2],
      },
      controls: [
        // "restart",
        "play",
        "progress",
        "current-time",
        "duration",
        // "mute",
        // "volume",
        "settings",
        "fullscreen",
      ],
      i18n: {
        play: "Play",
        pause: "Pausa",
        currentTime: "Tempo atual",
        duration: "Duração",
        volume: "Volume",
        settings: "Configurações",
        speed: "Velocidade",
        start: "Iniciar",
        enterFullscreen: "Tela cheia",
        exitFullscreen: "Sair da tela cheia",
      },
    }}
  />
);

export default VideoPlayer;
